import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isFinite } from 'lodash';
import { prettifyNumber } from '@nexio/emvio-util-app';

import Widget from '../Widget/Widget';

import './ChargebacksWidget.scss';

export default class ChargebacksWidget extends Component {
    static propTypes = {
        mtdChargebackCount: PropTypes.number,
        mtdTransactionCount: PropTypes.number,
        previousMonthChargebackCount: PropTypes.number,
        previousMonthTransactionCount: PropTypes.number
    };

    renderChargebackPercentage(data) {
        return (
            <Fragment>
                <div className="widget-heading">{data.title}</div>
                <div className="widget-value">{data.value}</div>
                {data.deltaDirection && data.deltaText && <div className="widget-delta">
                    <span className="material-icons">
                        {data.deltaDirection === 'up' ? 'arrow_drop_up' : 'arrow_drop_down'}
                    </span>
                    {data.deltaText}
                </div>}
            </Fragment>
        );
    }

    renderChargebackCount(data) {
        return (
            <Fragment>
                <div className="chargeback-container">
                    <span className="chargeback-text">MTD Chargebacks Count</span>
                    <span className="chargeback-count">{data.monthToDateCount}</span>
                </div>
                <div className="chargeback-container">
                    <span className="chargeback-text">Previous Month Chargeback Count</span>
                    <span className="chargeback-count">{data.previousMonthChargebackCount}</span>
                </div>
            </Fragment>
        );
    }

    render() {
        const {
            mtdChargebackCount,
            mtdTransactionCount,
            previousMonthChargebackCount,
            previousMonthTransactionCount
        } = this.props;

        const mtdChargebackPercentage = (mtdChargebackCount / mtdTransactionCount) * 100;
        const previousMonthChargebackPercentage = (previousMonthChargebackCount / previousMonthTransactionCount) * 100;
        const mtdVsPreviousMonthChargebackPercentage = mtdChargebackPercentage - previousMonthChargebackPercentage;

        const totalString = isFinite(mtdChargebackPercentage) ? prettifyNumber(mtdChargebackPercentage, 2, 2) + '%' : '--';

        const chargebackPercentage = {
            title: 'MTD Chargeback Percentage',
            value: totalString,
            deltaText: isFinite(mtdVsPreviousMonthChargebackPercentage) ? `${prettifyNumber(Math.abs(mtdVsPreviousMonthChargebackPercentage), 0, 2)}% from previous month` : '',
            deltaDirection: isFinite(mtdVsPreviousMonthChargebackPercentage) && mtdVsPreviousMonthChargebackPercentage > 0 ? 'up' : 'down'
        };

        const chargebackCount = {
            monthToDateCount: mtdChargebackCount,
            previousMonthChargebackCount
        };

        return (
            <div className="chargebacks-widget widget-layout">
                <div className="widget-title">
                    Chargebacks
                </div>
                <Widget
                    left={this.renderChargebackPercentage(chargebackPercentage)}
                    right={this.renderChargebackCount(chargebackCount)}
                    variant="dark"
                />
            </div>
        );
    }
}
